import { getChannelAPIPath } from '@treasury/core/http';

AchFileActivityService.$inject = ['$resource', '$http', '$filter'];

export default function AchFileActivityService($resource, $http, $filter) {
    return {
        search,
        getsourcelist,
        deleteFile,
        downloadNachaFile,
        processNachaFile,
    };

    function search(message) {
        return $resource(
            `${getChannelAPIPath()}achFileActivity`,
            {},
            { search: { method: 'POST', isArray: true } }
        ).search(message).$promise;
    }

    function getsourcelist() {
        return $resource(
            `${getChannelAPIPath()}achFileActivity/getACHSourceList`,
            {},
            { get: { method: 'GET', isArray: true } }
        ).get().$promise;
    }

    function downloadNachaFile(fileArchiveId) {
        return $http
            .get(`${getChannelAPIPath()}achFileActivity/getNachaFileContent/${fileArchiveId}`, {
                responseType: 'arraybuffer',
            })
            .then(response => response.data);
    }

    function deleteFile(fileId) {
        return $resource(`${getChannelAPIPath()}achFileActivity/delete`, { fileId }).delete()
            .$promise;
    }

    function processNachaFile(fileId) {
        return $resource(
            `${getChannelAPIPath()}achFileActivity/process/${fileId}`,
            {},
            { search: { method: 'POST' } }
        ).search(fileId).$promise;
    }
}
